import { makeAutoObservable, runInAction } from "mobx";

export default class panelStore {
  panel = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.panel = [];
    runInAction(() => {
      this.panel = data;
    });
  };

  deletePanel = (id) => {
    let newState = this.panel.filter((panel) => panel.id !== id);
    this.panel = [];
    this.panel = newState;
  };
}